import { Icons } from '@agro-club/agroclub-shared'
import { LogisticRequest } from 'modules/domain/logisticsKR/types'
import { ListRequestParams } from 'modules/domain/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { AddDraftTripModal } from 'views/pages/LogisticsKR/components/AddDraftTripModal/AddDraftTripModal'
import { ContentBlock } from 'views/pages/LogisticsKR/components/styled'
import { TableSectionContainer, TableSectionHeader, TableSectionHeaderRightBlock, TableSectionTitle } from '../styled'
import { OnApprovalTripsTable } from './OnApprovalTripsTable'

interface Props {
  request: LogisticRequest
  listRequestParams: ListRequestParams
  setListRequestParams: (params: ListRequestParams) => void
}

export const OnApprovalTripsTableSection: FC<Props> = ({ request, listRequestParams, setListRequestParams }) => {
  const { t } = useTranslation('logisticsKR')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <ContentBlock>
      <TableSectionContainer>
        <TableSectionHeader>
          <TableSectionTitle>{t('details.tableSections.approvedHeading')}</TableSectionTitle>

          <TableSectionHeaderRightBlock>
            <AButton id="addTrip" color="approve" Icon={Icons.IconPlus} onClick={() => setIsModalOpen(true)} />
          </TableSectionHeaderRightBlock>
        </TableSectionHeader>

        <OnApprovalTripsTable
          request={request}
          listRequestParams={listRequestParams}
          setListRequestParams={setListRequestParams}
        />
      </TableSectionContainer>

      {isModalOpen && (
        <AddDraftTripModal
          activeRequest={request}
          onClose={setIsModalOpen}
          onSuccess={() =>
            setListRequestParams({
              ...defaultListRequestParams,
              filter: { approve_stage: 'on_approve' },
            })
          }
        />
      )}
    </ContentBlock>
  )
}
